import React from 'react';

const ProductDesign = () => {
  return (
    <section className="bg-white py-12 sm:py-20 font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="max-w-4xl mb-10 sm:mb-12">
          <h2 className="text-3xl text-2xl sm:text-3xl lg:text-4xl font-bold text-cogBrand mb-4 sm:mb-6 tracking-tight">
            Engineering support from design to production
          </h2>
           
          <p className="text-base sm:text-lg text-cogBlue/80 leading-relaxed">
            Every harness we build starts on the engineering side, long before it reaches the
            production floor. Our team works across industry-standard design and validation
            software to develop schematics, routing, and drawings that OEMs can rely on, then
            carries that same design intent through 3D routing, DMU, and VLO simulation to confirm
            the harness will fit, route, and perform exactly as intended once it's built.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          
          {/* Card 1: Electrical Harness Design */}
          <div className="p-6 sm:p-8 bg-gray-50/50 border border-gray-200 rounded-sm hover:shadow-lg hover:border-cogCyan/30 transition-all duration-300 flex flex-col justify-between">
            <div>
              <div className="h-16 mb-6 flex items-center">
                <img 
                  className="h-full object-contain" 
                  alt="Icon representing electrical schematic design, showing a simplified wiring diagram with connector nodes and routed pathways." 
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQvmZXhDIu1IToNR5wYtlR0SB3CDvbblcYsyr5vHLUNw&s"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-cogBrand mb-3 tracking-tight">
                Electrical Harness Design
              </h3>
              <p className="text-sm sm:text-base text-cogBlue/80 mb-6 leading-relaxed">
                We use Zuken and Capital H to build out schematic design, wiring architecture, and
                harness drawings, giving OEMs clear, accurate documentation to work from at every
                stage. Combined with CAD-based routing, this lets us plan wire paths, connector
                placements, and branch points before a single harness is built, reducing rework and
                keeping engineering changes easy to trace back through the drawing set.
              </p>
            </div>
          </div>

          {/* Card 2: Advanced Design Validation */}
          <div className="p-6 sm:p-8 bg-gray-50/50 border border-gray-200 rounded-sm hover:shadow-lg hover:border-cogCyan/30 transition-all duration-300 flex flex-col justify-between">
            <div>
              <div className="h-16 mb-6 flex items-center">
                <img 
                  className="h-full object-contain" 
                  alt="Icon representing 3D mechanical and electrical modeling, showing a wireframe cable routed through a simplified vehicle chassis outline." 
                  src="https://upload.wikimedia.org/wikipedia/commons/d/df/PTC_Creo_logo.svg"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-cogBrand mb-3 tracking-tight">
                Advanced Design Validation
              </h3>
              <p className="text-sm sm:text-base text-cogBlue/80 mb-6 leading-relaxed">
                Using Creo, Creo Cabling, and CATIA, we model harnesses mechanically and
                electrically before production begins, then validate the design through 3D
                routing, DMU, and VLO simulation to check clearances, bend radii, and fit within
                the assembly. This step confirms manufacturing feasibility early, so issues get
                caught on screen instead of on the line, and the harness you receive matches the
                design intent the first time.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ProductDesign;